import { DraggableList, t } from 'owc-react-lib-common';
import * as React from 'react';
import { Loader } from 'src/components/Loader';
import { Icon } from 'src/components/Icon';
import { View } from 'src/components/View';
import { Text } from 'src/components/Text';
import { useAlerts } from "src/hooks/useAlerts";
import { useComponentDidMount } from "src/hooks/useComponentDidMount";
import * as EventService from 'src/services/EventService';
import { EventContext } from '../EventContext';
import { Button } from 'src/components/Button';

export const CategoriesOrder = ({onClose}: any) => {
  const alerts = useAlerts();
  const { data, setData } = React.useContext(EventContext);
  const [list, setList] = React.useState<any[]>([]);
  const [loading, setLoading] = React.useState(true);

  useComponentDidMount(async () => {
    setList(data?.eventCategories || []);
    setLoading(false);
  });

  const onItemDrop = (newCategoriesList: any[]) => {
    for (let i = 0; i < newCategoriesList.length; i++) {
      newCategoriesList[i].order = i + 1;
    }
    setList([...newCategoriesList]);
  };

  const handleSave = async () => {
    try {
      await EventService.updateOrderEventCategory(list);
      alerts.create({ text: t('global.success'), type: 'success' });
      setData({ ...data, eventCategories: [...list] });
      onClose();
    } catch (error) {
      alerts.createDSMError(error);
    }
  };

  const renderItemContent = (_data: any) => (
    <View key={_data?.id} style={{borderWidth: 1, borderColor: '#ccc', borderRadius: 3, padding: 5, display: 'flex', flexDirection: 'row', alignItems:'center'}}>
      <Icon color={'#ccc'} name='draganddrop'/><Text marginTop={0}> {_data.name}</Text>
    </View>
  );

  if (loading) {
    return <Loader/>
  }

  return (
    <View>
      <Text style={{marginBottom: 20}}>{t('admin.events.categoriesOrderDescription')}</Text>
      <DraggableList
        data={list}
        renderItemContent={renderItemContent}
        handleDrop={onItemDrop}
        internalState={true}
      />
      <View style={{marginTop: 20, display: 'flex', flexDirection: 'row'}}>
        <Button label={t('global.save')} containerStyle={{marginRight: 10}}  onPress={handleSave}  />
        <Button type='danger' label={t('global.cancel')}  onPress={onClose}  />

      </View>
    </View>
  );
}